/**
 * Affiliate Product Data
 *
 * Product recommendations mapped to species categories.
 *
 * Affiliate Programs:
 * - Viator (P00282299): 8% commission on tours/experiences
 * - Amazon Associates (wildlifemigra-20): 1-4% commission on gear
 */

// VIATOR EXPERIENCES - Primary (8% commission)
export const viatorExperiences = {
  birds: [
    {
      id: 'exp-bird-watching',
      name: 'Costa Rica Birdwatching Tour',
      description: 'Spot 400+ species including quetzals and toucans with expert guides.',
      price: 'From $95',
      image: 'https://images.unsplash.com/photo-1552728089-57bdde30beb3?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=birdwatching%20costa%20rica',
      category: 'birds',
      program: 'viator'
    },
    {
      id: 'exp-flamingo',
      name: 'Flamingo Watching Mexico',
      description: 'See thousands of pink flamingos in the Yucatan biosphere.',
      price: 'From $75',
      image: 'https://images.unsplash.com/photo-1497206365907-f5e630693df0?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=flamingo%20celestun%20mexico',
      category: 'birds',
      program: 'viator'
    },
    {
      id: 'exp-penguin',
      name: 'Penguin Colony Tour Argentina',
      description: 'Visit Punta Tombo, home to 200,000+ Magellanic penguins.',
      price: 'From $120',
      image: 'https://images.unsplash.com/photo-1551986782-d0169b3f8fa7?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=penguin%20punta%20tombo%20argentina',
      category: 'birds',
      program: 'viator'
    },
    {
      id: 'exp-puffin',
      name: 'Puffin Watching Iceland',
      description: 'See Atlantic puffins in their natural cliff-side habitat.',
      price: 'From $85',
      image: 'https://images.unsplash.com/photo-1598439210625-5067c578f3f6?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=puffin%20watching%20iceland',
      category: 'birds',
      program: 'viator'
    }
  ],
  mammals: [
    {
      id: 'exp-safari',
      name: 'Serengeti Safari Tour',
      description: 'Witness the Great Migration. Multi-day guided wildlife experience.',
      price: 'From $2,500',
      image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=serengeti%20safari&destId=5459',
      category: 'mammals',
      program: 'viator'
    },
    {
      id: 'exp-gorilla',
      name: 'Gorilla Trekking Rwanda',
      description: 'Once-in-a-lifetime encounter with mountain gorillas.',
      price: 'From $1,500',
      image: 'https://images.unsplash.com/photo-1518709766631-a6a7f45921c3?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=gorilla%20trekking%20rwanda',
      category: 'mammals',
      program: 'viator'
    },
    {
      id: 'exp-elephant',
      name: 'Elephant Sanctuary Thailand',
      description: 'Ethical elephant encounters at rescue sanctuaries.',
      price: 'From $80',
      image: 'https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=elephant%20sanctuary%20thailand',
      category: 'mammals',
      program: 'viator'
    },
    {
      id: 'exp-bear',
      name: 'Bear Watching Alaska',
      description: 'Watch grizzly bears fishing for salmon in the wild.',
      price: 'From $650',
      image: 'https://images.unsplash.com/photo-1530595467537-0b5996c41f2d?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=bear%20watching%20alaska',
      category: 'mammals',
      program: 'viator'
    }
  ],
  marine: [
    {
      id: 'exp-whale',
      name: 'Hawaii Whale Watching',
      description: 'Get up close with humpback whales. Guaranteed sightings.',
      price: 'From $89',
      image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=whale%20watching%20hawaii',
      category: 'marine',
      program: 'viator'
    },
    {
      id: 'exp-shark',
      name: 'Great White Shark Diving',
      description: 'Cage dive with great whites in South Africa.',
      price: 'From $175',
      image: 'https://images.unsplash.com/photo-1560275619-4662e36fa65c?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=shark%20cage%20diving%20south%20africa',
      category: 'marine',
      program: 'viator'
    },
    {
      id: 'exp-swim-dolphins',
      name: 'Swim with Wild Dolphins',
      description: 'Snorkel alongside spinner dolphins in their natural habitat.',
      price: 'From $150',
      image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=swim%20dolphins%20hawaii',
      category: 'marine',
      program: 'viator'
    }
  ],
  insects: [
    {
      id: 'exp-monarch',
      name: 'Monarch Butterfly Sanctuary',
      description: 'Visit the magical overwintering sites in Mexico.',
      price: 'From $150',
      image: 'https://images.unsplash.com/photo-1470093851219-69951fcbb533?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=monarch%20butterfly%20sanctuary%20mexico',
      category: 'insects',
      program: 'viator'
    }
  ],
  reptiles: [
    {
      id: 'exp-turtle',
      name: 'Sea Turtle Nesting Tour',
      description: 'Witness sea turtles nesting on Costa Rican beaches.',
      price: 'From $75',
      image: 'https://images.unsplash.com/photo-1591025207163-942350e47db2?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=sea%20turtle%20costa%20rica',
      category: 'reptiles',
      program: 'viator'
    }
  ],
  crustaceans: [
    {
      id: 'exp-crab',
      name: 'Christmas Island Red Crab Migration',
      description: 'Experience the world\'s largest land crab migration.',
      price: 'From $3,500',
      image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=christmas%20island%20red%20crab',
      category: 'crustaceans',
      program: 'viator'
    }
  ],
  general: [
    {
      id: 'exp-safari-general',
      name: 'African Safari Experience',
      description: 'See the Big Five in their natural habitat.',
      price: 'From $350',
      image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=african%20safari',
      category: 'general',
      program: 'viator'
    },
    {
      id: 'exp-whale-general',
      name: 'Whale Watching Adventure',
      description: 'Encounter magnificent whales in the wild.',
      price: 'From $89',
      image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=whale%20watching',
      category: 'general',
      program: 'viator'
    },
    {
      id: 'exp-wildlife-general',
      name: 'Wildlife Photography Tour',
      description: 'Capture stunning wildlife with expert photographer guides.',
      price: 'From $200',
      image: 'https://images.unsplash.com/photo-1504173010664-32509aeebb62?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=wildlife%20photography%20tour',
      category: 'general',
      program: 'viator'
    },
    {
      id: 'exp-galapagos',
      name: 'Galapagos Islands Tour',
      description: 'Discover unique wildlife found nowhere else on Earth.',
      price: 'From $1,200',
      image: 'https://images.unsplash.com/photo-1544550581-5f7ceaf7f992?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=galapagos%20islands%20wildlife',
      category: 'general',
      program: 'viator'
    },
    {
      id: 'exp-rainforest',
      name: 'Amazon Rainforest Expedition',
      description: 'Explore the worlds most biodiverse ecosystem.',
      price: 'From $450',
      image: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=400&h=400&fit=crop',
      url: 'https://www.viator.com/searchResults/all?pid=P00282299&mcid=42383&medium=link&text=amazon%20rainforest%20wildlife',
      category: 'general',
      program: 'viator'
    }
  ]
};

// AMAZON GEAR - Secondary (1-4% commission)
const affiliateProducts = {
  birds: [
    {
      id: 'bird-binoculars',
      name: 'Nikon Monarch M5 Binoculars',
      description: 'Crystal-clear optics for birdwatching. Waterproof and fog-proof.',
      price: '$297',
      image: 'https://images.unsplash.com/photo-1509460913899-515f1df34fea?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B09GV5J647?tag=wildlifemigra-20',
      category: 'birds',
      program: 'amazon'
    },
    {
      id: 'bird-field-guide',
      name: 'Sibley Guide to Birds',
      description: 'The definitive guide to North American birds. 6,600+ illustrations.',
      price: '$35',
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/030795790X?tag=wildlifemigra-20',
      category: 'birds',
      program: 'amazon'
    },
    {
      id: 'bird-camera',
      name: 'Canon 100-400mm Lens',
      description: 'Professional telephoto lens for bird photography.',
      price: '$1,899',
      image: 'https://images.unsplash.com/photo-1617005082133-548c4dd27f35?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B00PF39PEY?tag=wildlifemigra-20',
      category: 'birds',
      program: 'amazon'
    },
    {
      id: 'bird-spotting-scope',
      name: 'Celestron Ultima 80 Spotting Scope',
      description: 'Perfect for distant bird observation with 20-60x zoom.',
      price: '$199',
      image: 'https://images.unsplash.com/photo-1610563166150-b34df4f4c858?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B0002CTZ70?tag=wildlifemigra-20',
      category: 'birds',
      program: 'amazon'
    }
  ],

  mammals: [
    {
      id: 'mammal-binoculars',
      name: 'Vortex Viper HD Binoculars',
      description: 'Premium glass for wildlife viewing. Lifetime warranty.',
      price: '$449',
      image: 'https://images.unsplash.com/photo-1502982899975-893c9cf39028?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B00FGTHNG4?tag=wildlifemigra-20',
      category: 'mammals',
      program: 'amazon'
    },
    {
      id: 'mammal-tracking',
      name: 'Tracking and the Art of Seeing',
      description: 'Learn to identify animal tracks, scat, and signs in the wild.',
      price: '$25',
      image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/0062735241?tag=wildlifemigra-20',
      category: 'mammals',
      program: 'amazon'
    },
    {
      id: 'mammal-safari-hat',
      name: 'Sunday Afternoons Charter Hat',
      description: 'UPF 50+ sun protection for long days in the field.',
      price: '$54',
      image: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B00EJ3I4PM?tag=wildlifemigra-20',
      category: 'mammals',
      program: 'amazon'
    },
    {
      id: 'mammal-trail-camera',
      name: 'Bushnell Core DS Trail Camera',
      description: 'Capture nocturnal wildlife with no-glow infrared technology.',
      price: '$149',
      image: 'https://images.unsplash.com/photo-1590486803833-1c5dc8ddd4c8?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07HV2RPTM?tag=wildlifemigra-20',
      category: 'mammals',
      program: 'amazon'
    }
  ],

  marine: [
    {
      id: 'marine-snorkel',
      name: 'Cressi Snorkeling Set',
      description: 'Professional-grade mask, snorkel, and fins for marine encounters.',
      price: '$79',
      image: 'https://images.unsplash.com/photo-1560053608-13721e0d69e8?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07BDGQR9S?tag=wildlifemigra-20',
      category: 'marine',
      program: 'amazon'
    },
    {
      id: 'marine-underwater-camera',
      name: 'GoPro HERO12 Black',
      description: 'Waterproof action camera for underwater wildlife footage.',
      price: '$399',
      image: 'https://images.unsplash.com/photo-1564466809058-bf4114d55352?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B0CDDY34GX?tag=wildlifemigra-20',
      category: 'marine',
      program: 'amazon'
    },
    {
      id: 'marine-wetsuit',
      name: 'ONeill Reactor Wetsuit',
      description: 'Stay warm during whale watching and snorkeling adventures.',
      price: '$119',
      image: 'https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07Q3YKB2K?tag=wildlifemigra-20',
      category: 'marine',
      program: 'amazon'
    },
    {
      id: 'marine-reef-sunscreen',
      name: 'Stream2Sea Reef Safe Sunscreen',
      description: 'Biodegradable SPF 30 sunscreen that protects marine life.',
      price: '$20',
      image: 'https://images.unsplash.com/photo-1521117660936-4aebb7027113?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B01IUC9DJA?tag=wildlifemigra-20',
      category: 'marine',
      program: 'amazon'
    }
  ],

  insects: [
    {
      id: 'insect-macro-lens',
      name: 'Canon 100mm Macro Lens',
      description: 'Stunning close-up photography of butterflies and insects.',
      price: '$599',
      image: 'https://images.unsplash.com/photo-1617005082133-548c4dd27f35?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B002NEGTSI?tag=wildlifemigra-20',
      category: 'insects',
      program: 'amazon'
    },
    {
      id: 'insect-butterfly-guide',
      name: 'Butterflies of North America',
      description: 'Comprehensive field guide with 700+ species.',
      price: '$28',
      image: 'https://images.unsplash.com/photo-1559386969-9f8942af0fba?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/0618768262?tag=wildlifemigra-20',
      category: 'insects',
      program: 'amazon'
    },
    {
      id: 'insect-net',
      name: 'Professional Butterfly Net',
      description: 'Lightweight telescoping net for catching and releasing.',
      price: '$24',
      image: 'https://images.unsplash.com/photo-1518882605630-8eb7a00c0d52?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07WGZQG3K?tag=wildlifemigra-20',
      category: 'insects',
      program: 'amazon'
    },
    {
      id: 'insect-hand-lens',
      name: 'Carson 10x LED Lighted Loupe',
      description: 'Examine butterfly wings and insect details up close.',
      price: '$15',
      image: 'https://images.unsplash.com/photo-1582719188393-bb71ca45dbb9?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B001G0R4RA?tag=wildlifemigra-20',
      category: 'insects',
      program: 'amazon'
    }
  ],

  reptiles: [
    {
      id: 'reptile-field-guide',
      name: 'Reptiles & Amphibians Field Guide',
      description: 'Identify over 600 species with detailed photos.',
      price: '$22',
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/0395904528?tag=wildlifemigra-20',
      category: 'reptiles',
      program: 'amazon'
    },
    {
      id: 'reptile-underwater-cam',
      name: 'SeaLife Micro 3.0 Camera',
      description: 'Underwater camera perfect for turtle and marine reptile photography.',
      price: '$499',
      image: 'https://images.unsplash.com/photo-1591025207163-942350e47db2?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B088P2K7LM?tag=wildlifemigra-20',
      category: 'reptiles',
      program: 'amazon'
    },
    {
      id: 'reptile-rash-guard',
      name: 'Tuga Snorkel Rash Guard',
      description: 'UPF 50+ sun protection for snorkeling with sea turtles.',
      price: '$45',
      image: 'https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07B8B13VG?tag=wildlifemigra-20',
      category: 'reptiles',
      program: 'amazon'
    },
    {
      id: 'reptile-headlamp',
      name: 'Petzl Actik Core Headlamp',
      description: 'Red light mode for night turtle watching without disturbance.',
      price: '$80',
      image: 'https://images.unsplash.com/photo-1567722066597-2bdf46547453?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B01KYTRJP6?tag=wildlifemigra-20',
      category: 'reptiles',
      program: 'amazon'
    }
  ],

  crustaceans: [
    {
      id: 'crust-tide-pool-guide',
      name: 'Tide Pools & Rocky Shores Guide',
      description: 'Explore coastal marine life including crabs and crustaceans.',
      price: '$18',
      image: 'https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/0520251180?tag=wildlifemigra-20',
      category: 'crustaceans',
      program: 'amazon'
    },
    {
      id: 'crust-waterproof-bag',
      name: 'Earth Pak Dry Bag',
      description: 'Keep gear dry while exploring tide pools and beaches.',
      price: '$22',
      image: 'https://images.unsplash.com/photo-1581889470536-467bdbe30cd0?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B0BBBWR2H6?tag=wildlifemigra-20',
      category: 'crustaceans',
      program: 'amazon'
    },
    {
      id: 'crust-water-shoes',
      name: 'SIMARI Water Shoes',
      description: 'Quick-dry shoes for rocky shores and tide pool exploration.',
      price: '$26',
      image: 'https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B0CLY52CY1?tag=wildlifemigra-20',
      category: 'crustaceans',
      program: 'amazon'
    },
    {
      id: 'crust-mesh-bag',
      name: 'Mesh Beach Bag',
      description: 'Sand-resistant bag perfect for tide pool exploration gear.',
      price: '$18',
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B07TQPY8JK?tag=wildlifemigra-20',
      category: 'crustaceans',
      program: 'amazon'
    }
  ],

  // General products shown when no specific category is selected
  general: [
    {
      id: 'general-binoculars',
      name: 'Celestron Nature DX Binoculars',
      description: 'Great all-around binoculars for wildlife watching.',
      price: '$139',
      image: 'https://images.unsplash.com/photo-1502982899975-893c9cf39028?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B00B73JONS?tag=wildlifemigra-20',
      category: 'general',
      program: 'amazon'
    },
    {
      id: 'general-camera',
      name: 'Sony A7 IV Camera Body',
      description: 'Professional mirrorless camera for wildlife photography.',
      price: '$2,498',
      image: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B09JZT6YK5?tag=wildlifemigra-20',
      category: 'general',
      program: 'amazon'
    },
    {
      id: 'general-world-guide',
      name: 'Wildlife of the World',
      description: 'DK\'s stunning guide to Earth\'s most amazing animals.',
      price: '$40',
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/1465438696?tag=wildlifemigra-20',
      category: 'general',
      program: 'amazon'
    },
    {
      id: 'general-daypack',
      name: 'Osprey Daylite Plus Daypack',
      description: 'Lightweight 20L pack perfect for wildlife excursions.',
      price: '$80',
      image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop',
      url: 'https://www.amazon.com/dp/B0D92HZMK2?tag=wildlifemigra-20',
      category: 'general',
      program: 'amazon'
    }
  ]
};

// === VIATOR EXPERIENCES HELPERS ===

/**
 * Get experiences for a specific category
 */
export const getExperiencesByCategory = (category, limit = 3) => {
  const experiences = viatorExperiences[category] || viatorExperiences.general;
  return experiences.slice(0, limit);
};

/**
 * Get experiences relevant to a specific species
 */
export const getExperiencesForSpecies = (species, limit = 2) => {
  if (!species || !species.category) {
    return getExperiencesByCategory('general', limit);
  }
  return getExperiencesByCategory(species.category, limit);
};

// === AMAZON GEAR HELPERS ===

/**
 * Get products for a specific category
 */
export const getProductsByCategory = (category, limit = 3) => {
  const products = affiliateProducts[category] || affiliateProducts.general;
  return products.slice(0, limit);
};

/**
 * Get products relevant to a specific species
 */
export const getProductsForSpecies = (species, limit = 2) => {
  if (!species || !species.category) {
    return getProductsByCategory('general', limit);
  }
  return getProductsByCategory(species.category, limit);
};

export default affiliateProducts;
